import axios, { AxiosRequestConfig } from 'axios';
import { NavigateFunction } from 'react-router-dom';
import { clearSessionCredentials } from '../globalFunctions';
import { Image } from '../types';

export class MediaContentDAO {
    static async store(
        token: string,
        navigate: NavigateFunction,
        idOwner: number,
        image: Image,
        model: 'user' | 'school'
    ) {
        try {
            const requestConfig: AxiosRequestConfig = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${token}`,
                    Accept: 'application/json'
                }
            };

            const formData = new FormData();

            formData.append('idOwner', idOwner.toString());

            if (image.file) {
                formData.append('image', image.file);
            }

            if (image.removeId) {
                formData.append('removeId', image.removeId.toString());
            }

            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/logicmanager/mediacontent/${model}`,
                formData,
                requestConfig
            );

            return response.data;
        } catch (error: any) {
            const message = `Erro ao salvar imagem ${
                error.response.status === 413 ? '(tamanho excede o limite de 10MB)' : ''
            }`;

            const response = {
                message: message,
                error: error
            };

            if ([401, 419].includes(error.response.status)) {
                // Unauthorized
                clearSessionCredentials(navigate);
            } else {
                console.error(response);
                return response;
            }
        }
    }
}
